import { MapPin } from "lucide-react";
import { STATUS_META } from "@/lib/constants";

export function StatusBadge({ status }) {
  const meta = STATUS_META[status] || STATUS_META.not_purchased;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-semibold ${meta.badge}`}
    >
      {meta.label}
    </span>
  );
}

export function LocationBadge({ location }) {
  if (!location) {
    return (
      <span
        data-testid="location-badge-unassigned"
        className="inline-flex items-center gap-1 rounded-md border border-red-200 bg-red-50 px-2 py-0.5 text-xs font-bold text-red-600"
      >
        <MapPin className="h-3 w-3" /> UNASSIGNED
      </span>
    );
  }
  return (
    <span
      data-testid="location-badge"
      className="inline-flex items-center gap-1 rounded-md border border-rose-100 bg-rose-50 px-2 py-0.5 text-xs font-semibold text-rose-700"
    >
      <MapPin className="h-3 w-3" /> {location}
    </span>
  );
}

export function QtyProgress({ ordered, purchased }) {
  const pct = ordered > 0 ? Math.min(100, (purchased / ordered) * 100) : purchased > 0 ? 100 : 0;
  const color = purchased <= 0 ? "#94A3B8" : purchased < ordered ? "#F59E0B" : "#10B981";
  return (
    <div data-testid="qty-progress" className="w-full">
      <div className="mb-1 flex items-center justify-between text-xs">
        <span className="font-semibold text-stone-700">
          {purchased}/{ordered} units
        </span>
        {purchased > ordered && (
          <span className="font-semibold text-emerald-600">+{purchased - ordered} buffer</span>
        )}
      </div>
      <div className="h-2 w-full rounded-full bg-stone-200">
        <div
          className="h-2 rounded-full transition-[width] duration-300"
          style={{ width: `${pct}%`, backgroundColor: color }}
        />
      </div>
    </div>
  );
}
